import ProfileLocked from "@components/templates/Profile/ProfileLocked";
import IntelLayout from "@components/layout/layout";
import { useState } from "react";

const SamplePort = () => {
  const [showNotification, setShowNotification] = useState(false);
  return (
    <IntelLayout
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}
      type={"portProfileLocked"}>
      <ProfileLocked key="Port Profile" countries="Intel Enterprise Logistics" heading="View port profile to get deep insights on its Trade Lanes, Logistic Companies working on it along with actual Importers and Exporters details" imgUrl="v1709809585/intel/Pro%20Lite%20Plan/port_profile_emptystate_rg7vek.svg" profileName="Port" />
    </IntelLayout>
  );
};

export default SamplePort;
